/**
 * Brand Rules API service
 */

import { apiClient as api } from "../../services/api/client";

export type FrequencyCap =
    | "1_day"
    | "3_days"
    | "1_week"
    | "2_weeks"
    | "1_month";

export interface BrandRules {
    id: string;
    brandId: string;
    tone: number;
    aggressiveness: number;
    forbiddenWords: string[];
    sendWindow: { start: string; end: string };
    maxBudgetUSD: number;
    frequencyCap: FrequencyCap;
    minRoi: number;
    fairnessCap: number;
    updatedAt: string;
    updatedBy: string;
}

type ApiResponse<T> = { success: boolean; data: T; error?: string };

export const brandRulesApi = {
    async get(brandId: string): Promise<ApiResponse<BrandRules>> {
        try {
            const response = await api.get("/brand-rules", {
                params: { brandId },
            });
            return response.data;
        } catch (err: any) {
            return {
                success: false,
                data: {} as BrandRules,
                error:
                    err?.response?.data?.error ||
                    err.message ||
                    "Error al cargar las reglas",
            };
        }
    },

    async upsert(
        params: Partial<BrandRules> & { brandId: string },
    ): Promise<ApiResponse<BrandRules>> {
        try {
            const response = await api.put("/brand-rules", params);
            return response.data;
        } catch (err: any) {
            return {
                success: false,
                data: {} as BrandRules,
                error:
                    err?.response?.data?.error ||
                    err.message ||
                    "Error al guardar las reglas",
            };
        }
    },
};
